import React, { useContext } from "react";
import { PAYMENT_MODES } from "constants/paymentModes";
import { VERNACULAR_DEFAULT_MESSAGES, VERNACULAR_STRING_IDS } from "constants/vernacularConstants";
import { useTheme } from "emotion-theming";
import { getIcons, ICONS_NAMES } from "helpers/utils/getIcons";
import { getStringFromId } from "helpers/vernacular";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { getPlatform } from "../../../helpers";

import EMIDesktop from "@nykaa/payment-sdk/src/EMI/desktop";
import EMI from "@nykaa/payment-sdk/src/EMI/mobile";
import { DEVICE_TYPE, BUTTON_TYPE } from "constants/index";
import { formatNumber } from "helpers/utils/numberFormatter";


const EmiWrapper = ({
    doPayment,
    isAccordianOpened,
    toggleNewPaymentAccordian,
    endIcon,
    isDisabled,
    strikedPaymentText,
}: any) => {
    const paymentContext: any = useContext(PaymentContext);
    const { applicationData } = useContext(ApplicationContext);
    const theme = useTheme() as Theme;
    const platform = getPlatform();

    const grandTotal = paymentContext?.orderAmount;
    const paymentInfo = paymentContext?.paymentInfo;
    const deviceType = applicationData?.deviceType;

    const emiInfo = paymentInfo?.emiInfo;
    const emiDisabledMsg = emiInfo?.emiDisabledMsg;
    const emiInfoMsg = emiInfo?.emiInfoMsg;
    const emiMinLimit = emiInfo?.emiMinLimit;
    const isNoCostEmiAvailable = emiInfo?.isNoCostEmiAvailable;

    const isSubmitButtonDisabled = grandTotal < emiMinLimit;
    const message = isSubmitButtonDisabled ? emiDisabledMsg : emiInfoMsg;
    let title = getStringFromId(VERNACULAR_STRING_IDS.EMI_TITLE, VERNACULAR_DEFAULT_MESSAGES.EMI_TITLE);

    if (deviceType === DEVICE_TYPE.DESKTOP) {
        title = getStringFromId(
            VERNACULAR_STRING_IDS.EMI_TITLE_DESKTOP,
            VERNACULAR_DEFAULT_MESSAGES.EMI_TITLE_DESKTOP
        );
    }

    const subTitle = getStringFromId(VERNACULAR_STRING_IDS.EMI_SUBTITLE, VERNACULAR_DEFAULT_MESSAGES.EMI_SUBTITLE);
    const noCostEmiText = getStringFromId(VERNACULAR_STRING_IDS.NO_COST_EMI, VERNACULAR_DEFAULT_MESSAGES.NO_COST_EMI);

    const payNowText = getStringFromId(
        VERNACULAR_STRING_IDS.DYNAMIC_PAY,
        `Pay ₹${formatNumber(grandTotal)}`,
        { count: grandTotal });

    const config = {
        isAccordianOpened,
        toggleAccordian: () => toggleNewPaymentAccordian(PAYMENT_MODES.EMI, isDisabled),
        endIcon,
        title,
        titleFont: deviceType === DEVICE_TYPE.DESKTOP ? theme.typography.sectionTitle : theme.typography.subTitleLG,
        subTitle,
        leadingIcon: getIcons(platform, ICONS_NAMES.EMI),
        isSubmitButtonDisabled,
        grandTotal,
        message,
        payNowText,
        revisedPayNowText: strikedPaymentText,
        alert: {
            leadingIcon: isSubmitButtonDisabled ? getIcons(platform, ICONS_NAMES.EMI_ALERT) : getIcons(platform, ICONS_NAMES.EMI_INFO_ICON),
            error: isSubmitButtonDisabled && true,
            info: !isSubmitButtonDisabled && true,
            font: theme?.typography?.paymentMethodAlert,
            text: message,
        },
        chipText: isNoCostEmiAvailable ? noCostEmiText : "",
        chipColor: theme?.colors?.info,
        chipBackgroundColor: theme?.colors?.info50,
        isDisabled,
        doPayment: () => doPayment(PAYMENT_MODES.EMI),
        theme,
        buttonType: BUTTON_TYPE.MEDIUM,
    };

    if (deviceType === DEVICE_TYPE.DESKTOP) {
        return <EMIDesktop {...config} />;
    }

    return <EMI {...config} theme={theme} />;
};

export default EmiWrapper;
